import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
      <div className='md-header'>
        <img className='md-header__left-logo' src={`${process.env.PUBLIC_URL}/sblogo.png`} alt='logo' width='117' />
        <img className='md-header__right-logo' src={`${process.env.PUBLIC_URL}/ymlogo.png`} alt='logo' width='117' />
      </div>
    );
  }
}

export default Header;
